import dayjs from 'dayjs'
/**
 * 时间相加处理函数
 * 注意：传入参数Date不遵循0~11月国际标准，以正常月份为准
 * @param {String} date 需要计算的时间(xxxx-xx-xx) 1~12月
 * @param {String | Number} plusDays 要加的天数(整数)
 * @returns {Date}
 */
export function getDateByAddDay(date, plusDays) {
  const reg1 = /\d{4}-\d+-\d+/
  const reg2 = /\d{4}\/\d+\/\d+/
  if (!reg1.test(date) && !reg2.test(date)) {
    throw new Error(
      'date format error, please use format like YYYY-MM-DD or YYYY/MM/DD'
    )
  }
  let dateArray = reg1.test(date) ? date.split('-') : date.split('/')
  // console.log('date parsed', dateArray)
  let year = +dateArray[0]
  let month = +dateArray[1]
  let day = +dateArray[2]
  let dateNew = dayjs(`${year}-${month}-${day}`)
  // console.log('dayjs', dateNew, dayjs(`2020-12-30`).toDate())
  let dayAadded = dateNew.add(+plusDays, 'day')
  // console.log(dayAadded)
  return dayAadded.toDate()
  // let oriDay = day
  // let secondMonthDays =
  //   (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0 ? 29 : 28
  // while (plusDays > 0) {
  //   oriDay = day
  //   day += plusDays
  //   switch (month) {
  //     case 4:
  //     case 6:
  //     case 9:
  //     case 11:
  //       if (day > 30) {
  //         plusDays -= 30 - oriDay + 1
  //         month++
  //         day = 1
  //       } else {
  //         plusDays = 0
  //       }
  //       break
  //     case 2:
  //       if (day > secondMonthDays) {
  //         plusDays -= secondMonthDays - oriDay + 1
  //         month++
  //         day = 1
  //       } else {
  //         plusDays = 0
  //       }
  //       break
  //     default:
  //       if (day > 31) {
  //         plusDays -= 31 - oriDay + 1
  //         day = 1
  //         month++
  //       } else {
  //         plusDays = 0
  //       }
  //   }
  //   if (month > 12) {
  //     month = 1
  //     year++
  //   }
  // }
  // let d = new Date(year, month, day)
  // console.log(
  //   year,
  //   month,
  //   day,
  //   d === new Date(year, month, day),
  //   __utils.dateFormat(d, 'YY-MM-DD'),
  // )
  // return d
}
/**
 * 日期比较
 * @param {Date} date
 * @param {Date} compareDate
 */
export function dateCompare(date, compareDate = new Date()) {
  const l = dayjs(date)
  const r = dayjs(compareDate)
  // console.log(l, l.toDate(), r, r.toDate())
  return l.toDate() >= r.toDate()
}
